const dragHelperPostFix = '_dragHelper';

/**
 * transforms a given id into a drag helper item id
 * @returns the new id to use for a drag helper item
 */
export function makeDragHelperItemId(id: string): string {
    return id + dragHelperPostFix;
}

/**
 * Returns true if the ID is for a drag helper item
 * @param id the id to check
 */
export function isDragItemId(id: string): boolean {
    return (
        id &&
        id.length >= dragHelperPostFix.length &&
        id.substring(id.length - 11) == dragHelperPostFix
    );
}
